import React from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import Button from 'components/Form/Button'
import {
  CreateNewFolderOutlined,
} from '@mui/icons-material'
import { buildFolderDragId } from '../utils'
import {
  FolderCreateRow,
  FolderList,
  InlineActions,
  InlineInput,
  SidebarDescription,
  SidebarHeader,
  SidebarPanel,
  SidebarTitle,
  SectionEyebrow,
} from '../styled'
import { FooterAction } from './styled'
import FavoritesFolderTarget from '../FavoritesFolderTarget'

export default function FolderSidebar({
  t,
  workspace,
  activeFolderId,
  creatingFolder,
  newFolderName,
  setNewFolderName,
  setCreatingFolder,
  handleCreateFolder,
  editingFolderId,
  editingFolderName,
  setEditingFolderId,
  setEditingFolderName,
  handleRenameFolder,
  handleDeleteFolder,
  setActiveFolder,
  isFolderBusy,
  busyState,
}) {
  return (
    <SidebarPanel>
      <SidebarHeader>
        <SectionEyebrow>{t('favorites')}</SectionEyebrow>
        <SidebarTitle>{t('favorites_workspace_title')}</SidebarTitle>
        <SidebarDescription>{t('favorites_workspace_description')}</SidebarDescription>
      </SidebarHeader>

      <FolderList>
        <FavoritesFolderTarget
          active={activeFolderId == null}
          count={workspace.unfiledCount}
          name={t('favorites_unfiled')}
          caption={t('favorites_unfiled_caption')}
          onClick={() => setActiveFolder(null)}
        />

        <SortableContext
          items={workspace.folders.map((folder) => buildFolderDragId(folder.id))}
          strategy={verticalListSortingStrategy}
        >
          {workspace.folders.map((folder) => (
            <FavoritesFolderTarget
              key={folder.id}
              folder={folder}
              active={folder.id === activeFolderId}
              editing={editingFolderId === folder.id}
              editingName={editingFolderName}
              onEditingNameChange={setEditingFolderName}
              onEditingCancel={() => {
                setEditingFolderId(null)
                setEditingFolderName('')
              }}
              onEditingSubmit={() => handleRenameFolder(folder.id)}
              onClick={() => setActiveFolder(folder.id)}
              onStartEdit={() => {
                setEditingFolderId(folder.id)
                setEditingFolderName(folder.name)
              }}
              onDelete={() => handleDeleteFolder(folder.id)}
              isBusy={isFolderBusy(folder.id)}
              placeholder={t('favorites_folder_name_placeholder')}
              doneLabel={t('done')}
              cancelLabel={t('cancel')}
            />
          ))}
        </SortableContext>
      </FolderList>

      {creatingFolder ? (
        <FolderCreateRow>
          <InlineInput
            autoFocus
            value={newFolderName}
            onChange={(event) => setNewFolderName(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') handleCreateFolder()
              if (event.key === 'Escape') {
                setCreatingFolder(false)
                setNewFolderName('')
              }
            }}
            placeholder={t('favorites_folder_name_placeholder')}
          />
          <InlineActions>
            <Button
              small
              color="primary"
              width="fit-content"
              onClick={handleCreateFolder}
              loading={busyState.creatingFolder}
            >
              {t('favorites_create_folder')}
            </Button>
            <Button
              small
              outline
              color="primary"
              width="fit-content"
              onClick={() => {
                setCreatingFolder(false)
                setNewFolderName('')
              }}
            >
              {t('cancel')}
            </Button>
          </InlineActions>
        </FolderCreateRow>
      ) : (
        <FooterAction>
          <Button
            small
            color="primary"
            width="fit-content"
            startIcon={<CreateNewFolderOutlined />}
            onClick={() => setCreatingFolder(true)}
          >
            {t('favorites_new_folder')}
          </Button>
        </FooterAction>
      )}
    </SidebarPanel>
  )
}
